import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getCreditPayments, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import { reportCreditPaymentsCrumb } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';

class CreditPayments extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `CreditPaymentsBeginDate`);
        this.props.formInput(date, `CreditPaymentsEndDate`);
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch ? this.props.branch.toString() : "ALL";
        let dateGroupBy = this.props.groupby;

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/creditpayments?beginDate=${beginDate}&endDate=${endDate}&branch=${branch}&dateGroupBy=${dateGroupBy}`, "PaymentReport");
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch ? this.props.branch.toString() : "ALL";
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let dateGroupBy = this.props.groupby;
        this.props.getCreditPayments({ beginDate, endDate, pageNumber, pageSize, branch, dateGroupBy });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }
    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.creditPayments && newProps.creditPayments.details && newProps.creditPayments.details.length > 0 ? newProps.creditPayments.details[0].totalRows : 0;
            this.setState({ totalRow: totalRow })
        }
    }
    render() {
        return (
            <Grid headerContent={reportCreditPaymentsCrumb}>
                <PageHeader 
                    title={LOOKUP.report.creditPayments.text} 
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-credit-payment" />}
                    description={LOOKUP.report.creditPayments.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                />
                {
                    this.state.showBody &&
                    <p className="text-right mt-2 blue-text">
                        <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                    </p>
                }
                {
                    this.state.showBody && this.props.creditPayments &&
                    <CardSimple>
                        <Body
                            creditPayments={this.props.creditPayments}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                            loggedBranch={this.props.loggedBranch}
                            branchForm={this.props.branch}
                        />
                        <Pagination
                            length={this.state.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        creditPayments: state.reports.creditPayments,
        loggedBranch: state.common.branchId,
        beginDate: state.form.CreditPaymentsBeginDate,
        endDate: state.form.CreditPaymentsEndDate,
        branch: state.form.CreditPaymentsBranchOption,
        groupby: state.form.CreditPaymentsGroupBy
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getCreditPayments: model => dispatch(getCreditPayments(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(CreditPayments));